module.exports = __webpack_public_path__ + "img/image-008.6c8ab3ee.png";